module.exports = __webpack_public_path__ + "static/media/bannerBackground.d1cca035.png";